export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_jobnexa-portal/artifacts/pt0sy104_Untitled%20design%20%2814%29.png';

export const navLinks = [
  { label: 'Why Jobnexa', href: '#why-jobnexa' },
  { label: 'Products & Services', href: '#products' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Pricing', href: '#pricing' },
];

export const appliedJobs = [
  {
    company: 'Google',
    favicon: 'https://www.google.com/favicon.ico',
    title: 'Program Manager',
    date: 'Dec 17, 2025',
    status: 'Active',
    description: 'A problem isn\'t truly solved until it\'s solved for all. Googlers build products and opportunities for everyone.',
  },
  {
    company: 'Microsoft',
    favicon: 'https://www.microsoft.com/favicon.ico',
    title: 'Software Engineer, Azure',
    date: 'Dec 16, 2025',
    status: 'Active',
    description: 'The Knowledge and Information Partnerships team is looking for experienced engineers.',
  },
];

export const resumes = [
  { name: 'Resume_Google.pdf', date: 'Oct 16, 2025' },
  { name: 'CV_Amazon.pdf', date: 'Oct 16, 2025' },
  { name: 'CV_Microsoft.pdf', date: 'Oct 14, 2025' },
];

export const submissions = [
  { name: 'Google_SWE.pdf', date: 'Nov 27' },
  { name: 'Amazon_PM.docx', date: 'Nov 24' },
  { name: 'Microsoft_DA.png', date: 'Nov 20' },
  { name: 'Meta_UX.pdf', date: 'Nov 18' },
];

export const responses = [
  { company: 'Google', favicon: 'https://www.google.com/favicon.ico', response: 'Phone', date: 'Nov 27' },
  { company: 'Amazon', favicon: 'https://www.amazon.com/favicon.ico', response: 'Interview', date: 'Nov 27' },
  { company: 'Microsoft', favicon: 'https://www.microsoft.com/favicon.ico', response: 'Assess', date: 'Nov 27' },
  { company: 'Meta', favicon: 'https://www.meta.com/favicon.ico', response: 'Phone', date: 'Nov 19' },
];

export const recruiters = [
  { initials: 'JD', name: 'John Davidson', role: 'Recruiter @ Google' },
  { initials: 'SM', name: 'Sarah Miller', role: 'Recruiter @ Amazon' },
  { initials: 'MK', name: 'Mike Kim', role: 'Manager @ Meta' },
  { initials: 'AL', name: 'Alex Lee', role: 'Talent @ Netflix' },
];

export const stats = [
  { value: '3x', label: 'Higher Interview Rate' },
  { value: '350+', label: 'Full time job offers since 2024' },
  { value: '200+', label: 'Companies hired our clients' },
  { value: '500+', label: 'Clients Served since 2025' },
  { value: '500+', label: 'Hours saved per Client' },
  { value: '3000+', label: 'Interviews secured since 2025' },
];

export const universityLogos = [
  'https://firststepjob.com/University%20logos/asu-3.svg',
  'https://firststepjob.com/University%20logos/florida-state-university.svg',
  'https://firststepjob.com/University%20logos/georgia-state-university.svg',
  'https://firststepjob.com/University%20logos/georgia-tech-yellow-jackets-2.svg',
  'https://firststepjob.com/University%20logos/indiana-state-university.svg',
  'https://firststepjob.com/University%20logos/texas-university.svg',
  'https://firststepjob.com/University%20logos/the-university-of-california.svg',
  'https://firststepjob.com/University%20logos/university-of-houston-1.svg',
  'https://firststepjob.com/University%20logos/university-of-maryland.svg',
  'https://firststepjob.com/University%20logos/university-of-michigan-3.svg',
  'https://firststepjob.com/University%20logos/university-of-minnesota.svg',
  'https://firststepjob.com/University%20logos/university-of-south-carolina.svg',
  'https://firststepjob.com/University%20logos/university-of-virginia-3.svg',
];

export const companyLogos = [
  'https://firststepjob.com/Company%20Logos/intel.svg',
  'https://firststepjob.com/Company%20Logos/jpmorgan-chase.svg',
  'https://firststepjob.com/Company%20Logos/logo-amazon.svg',
  'https://firststepjob.com/Company%20Logos/metlife-1.svg',
  'https://firststepjob.com/Company%20Logos/red-hat.svg',
  'https://firststepjob.com/Company%20Logos/salesforce-2.svg',
  'https://firststepjob.com/Company%20Logos/splunk-1.svg',
  'https://firststepjob.com/Company%20Logos/goldman-sachs-2.svg',
  'https://firststepjob.com/Company%20Logos/deloitte-1.svg',
  'https://firststepjob.com/Company%20Logos/bmw-2.svg',
  'https://firststepjob.com/Company%20Logos/uber-2.svg',
  'https://firststepjob.com/Company%20Logos/honeywell-1.svg',
  'https://firststepjob.com/Company%20Logos/infosys-3.svg',
  'https://firststepjob.com/Company%20Logos/the-home-depot.svg',
  'https://firststepjob.com/Company%20Logos/toyota-1.svg',
  'https://firststepjob.com/Company%20Logos/american-airlines-2.svg',
  'https://firststepjob.com/Company%20Logos/ally-bank.svg',
  'https://firststepjob.com/Company%20Logos/td-bank-1.svg',
  'https://firststepjob.com/Company%20Logos/discover-2.svg',
  'https://firststepjob.com/Company%20Logos/hcltech-1.svg',
];

export const howItWorks = [
  {
    step: '01',
    title: "Let's Talk",
    description: 'Start with a free consultation to discuss your career goals, target roles, and current challenges. This helps us understand your background and expectations.',
  },
  {
    step: '02',
    title: 'Sign Up & Choose a Plan',
    description: 'Create your Jobnexa account and subscribe to a plan that fits your goals. Once enrolled, your dashboard and support channels are activated immediately.',
  },
  {
    step: '03',
    title: 'We Apply, You Relax',
    description: 'Our team applies to relevant jobs on your behalf while you track all applied jobs, tailored resumes, submission proofs, and responses directly from your dashboard.',
  },
  {
    step: '04',
    title: 'Prepare and Succeed',
    description: 'Use the Interview Prep Center and Learning Center to practice coding, MCQs, and mock interviews. Build confidence, sharpen skills, and be ready when opportunity knocks.',
  },
];

export const pricingPlans = {
  customResume: [
    {
      name: 'Falcon',
      price: { USD: 349, CAD: 469, AUD: 539, INR: 29499 },
      duration: '100 days',
      perDay: { USD: '~$3.5', CAD: '~C$4.7', AUD: '~A$5.4', INR: '~₹295' },
      jobs: '999 jobs',
      features: [
        '999 jobs for 100 days',
        'Resume Editing for Each Application',
        'Cover Letter Customization',
        'No Limit on Job titles or Categories',
      ],
      popular: false,
      clientDelegated: true,
    },
    {
      name: 'Premium',
      price: { USD: 449, CAD: 599, AUD: 689, INR: 37499 },
      duration: '100 days',
      perDay: { USD: '~$4.5', CAD: '~C$6.0', AUD: '~A$6.9', INR: '~₹375' },
      jobs: '~2.4k jobs',
      features: [
        '30+ Applications a day',
        'Resume Editing for Each Application',
        'No Limit on Job titles or Categories',
        'Dedicated Human Application Expert',
      ],
      popular: true,
      gradOffer: true,
    },
    {
      name: 'Premium Plus',
      price: { USD: 599, CAD: 799, AUD: 919, INR: 49999 },
      duration: '100 days',
      perDay: { USD: '~$6.0', CAD: '~C$8.0', AUD: '~A$9.2', INR: '~₹500' },
      jobs: '~2.4k jobs',
      features: [
        'Everything in Premium and',
        'Personalized website',
        'Access to 2k+ Jobnexa Recruiter Database',
        'Recruiter & Hiring Manager Outreach',
      ],
      popular: false,
    },
  ],
  noCustomResume: [
    {
      name: 'Essentials',
      price: { USD: 159, CAD: 215, AUD: 245, INR: 13299 },
      duration: '100 days',
      perDay: { USD: '~$1.6', CAD: '~C$2.2', AUD: '~A$2.5', INR: '~₹133' },
      jobs: '~2.0k jobs',
      features: [
        '25+ Applications a day',
        'Google Drive & WhatsApp Updates',
        '1 Job Title or Category',
        'Dedicated Human Application Expert',
      ],
      popular: false,
    },
    {
      name: 'Falcon Lite',
      price: { USD: 199, CAD: 269, AUD: 309, INR: 16599 },
      duration: '100 days',
      perDay: { USD: '~$2.0', CAD: '~C$2.7', AUD: '~A$3.1', INR: '~₹166' },
      jobs: '999 jobs',
      features: [
        '999 jobs for 100 days',
        'Google Drive & WhatsApp Updates',
        '3 Job Title or Category',
        'Dedicated Human Application Expert',
      ],
      popular: false,
      clientDelegated: true,
    },
    {
      name: 'Elite',
      price: { USD: 249, CAD: 335, AUD: 385, INR: 20799 },
      duration: '100 days',
      perDay: { USD: '~$2.5', CAD: '~C$3.4', AUD: '~A$3.9', INR: '~₹208' },
      jobs: '~3.6k jobs',
      features: [
        'Everything in Essentials and',
        '45+ Applications a day',
        '3 Job Title or Category',
        'ATS score for resume',
      ],
      popular: false,
    },
  ],
};

export const testimonials = [
  {
    quote: 'I didn\'t have time to apply for jobs daily. Jobnexa handled everything for me, and within weeks I started getting more responses.',
    name: 'Rahul',
    role: 'Software Developer',
  },
  {
    quote: 'Consistent applications made a big difference. I was able to focus on interview prep while they handled the process.',
    name: 'Priya',
    role: 'Data Analyst',
  },
];

export const faqs = [
  {
    question: 'How does Jobnexa apply to jobs on my behalf?',
    answer: 'Our dedicated team manually applies to jobs for you. Each application includes a custom-tailored resume built specifically for the role. No bots, no Easy Apply — every submission is handled by a human expert.',
  },
  {
    question: 'How many jobs will be applied per day?',
    answer: 'Depending on your plan, we apply to 30+ jobs daily. Our Falcon plans offer 780 total applications over 30 days with client-delegated job links.',
  },
  {
    question: 'Do you take a percentage of my salary after placement?',
    answer: 'Absolutely not. We have simple, transparent pricing with zero commissions, no salary cuts, and no hidden fees. You pay once for your plan and that\'s it.',
  },
  {
    question: 'Can I send you specific job links to apply?',
    answer: 'Yes! With our On-Demand Job Application feature, you can share any job link and your Application In-Charge will apply within minutes. This is included with every plan at no extra cost.',
  },
  {
    question: 'What kind of support do I get?',
    answer: 'You get a dedicated WhatsApp group or Slack Channel for quick updates, plus a ticketing system for tracking requests, issues, and follow-ups throughout your 30-day journey.',
  },
];

export const whyFeatures = [
  {
    title: 'Personalized Dashboard',
    subtitle: 'All your job search activity in one place',
    description: 'View all jobs applied on your behalf, the tailored resume used for each role, verified application submission proofs, and any responses received from companies or recruiters.',
    highlight: 'One login. One dashboard.',
  },
  {
    title: 'Custom Resume &',
    titleAccent: '45+ Daily Applications',
    description: 'Every application gets a custom resume crafted using Jobnexa\'s in-house engine. We apply to 45+ real jobs daily— No Easy Apply. No bots. Every application is handled by a dedicated Application Incharge.',
    highlight: 'Jobnexa-Source and Apply jobs for you.',
  },
  {
    title: 'On-Demand Job Applications',
    subtitle: 'See a role you like? Consider it applied.',
    features: [
      { title: 'Fast Processing', desc: 'Applications submitted within 15 minutes of your request.' },
      { title: 'Expert Review', desc: 'Every link is checked by a human expert before applying.' },
      { title: 'Unlimited', desc: 'No caps on how many jobs you can send us daily.' },
    ],
  },
  {
    title: 'No Percentage Games',
    subtitle: 'Simple pricing. Zero surprises.',
    description: 'Choose a plan and pay once. No commissions. No salary cuts after placement. No hidden fees. Everything is clear, upfront, and transparent from day one.',
  },
  {
    title: 'Portfolio, Interview &',
    titleAccent: 'Learning Center',
    description: 'Get job-ready, end to end. Get a personal portfolio website, structured interview prep, and an industry-focused learning center.',
    subDescription: 'Access real interview experiences shared by peers, company-specific preparation modules and guided learning paths tailored to your target roles and tech stack.',
  },
  {
    title: 'Dedicated Support: Ticketing + WhatsApp/Slack',
    subtitle: 'Your job search, fully supported.',
    description: 'Get a dedicated WhatsApp group/ Slack Channel for quick updates and a ticketing system for tracking requests, issues, and follow-ups. Stay informed with clear communication throughout your 100-day journey.',
  },
];

export const productFeatures = [
  {
    title: 'Access applied jobs',
    description: 'View every job applied on your behalf in real time. Search by company or application date, access the full job description even after it expires.',
  },
  {
    title: 'Access tailored resumes',
    description: 'All resumes crafted for your applications are stored in one place—organized, searchable, and available anytime.',
  },
  {
    title: 'Submission proofs',
    description: 'Every application comes with verified submission proof, giving you complete transparency and confidence.',
  },
  {
    title: 'Track responses',
    description: 'We monitor recruiter and company responses and notify you as updates arrive.',
  },
  {
    title: 'Recruiter outreach',
    description: 'We proactively email recruiters and hiring managers when strong job matches are found.',
  },
  {
    title: 'Delegate jobs you spot',
    description: 'Found a specific role you want? Send the link to us directly through your dashboard.',
  },
];

export const currencySymbols = {
  USD: '$',
  CAD: 'C$',
  AUD: 'A$',
  INR: '₹',
};

export const currencyFlags = {
  USD: '🇺🇸',
  CAD: '🇨🇦',
  AUD: '🇦🇺',
  INR: '🇮🇳',
};
